import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";

export default function Header({ inApp = false }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header
      className="sticky top-0 z-40 border-b border-[#282C30] bg-[#0C0D0E]/80 backdrop-blur-xl"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6 py-3.5">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <div className="w-8 h-8 rounded-md bg-[#00E676] grid place-items-center text-[#001b09] font-black">C</div>
          <span className="font-display font-extrabold tracking-tight text-lg">clawback</span>
          <span className="hidden sm:inline font-mono text-[10px] px-1.5 py-0.5 rounded-sm border border-[#282C30] text-[#A0A7B0] tracking-widest uppercase">
            money-recovery agent
          </span>
        </Link>
        <div className="flex items-center gap-2">
          {inApp && user ? (
            <>
              <span className="hidden sm:inline text-sm text-[#A0A7B0] font-mono" data-testid="header-user-email">
                {user.email}
              </span>
              <Button variant="outline" onClick={async () => { await logout(); nav("/"); }} data-testid="logout-button" className="btn-outline-paper">
                Sign out
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm text-[#A0A7B0] hover:text-white px-3 py-2" data-testid="nav-login">
                Sign in
              </Link>
              <Link to="/register" data-testid="nav-register">
                <Button className="btn-emerald" data-testid="header-cta-button">Start recovering</Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
